// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__xuGFx","customTooltip":"Navbar_customTooltip__37SmB","signin":"Navbar_signin__1aQFw","signInText":"Navbar_signInText__3C6dq"};